<template>
  <div>
    <Headersys />
    <div class="content">
      <!--开启摄像头-->
      <el-button type="primary" @click="callCamera">开启摄像头</el-button>
      <el-button type="success" @click='changePhoto'>获取摄像头列表</el-button>
      <el-button type="info" @click="closeCamera">关闭摄像头</el-button>
      <el-select v-model="modelSel" placeholder="选择摄像头" @change="changeSel">
        <el-option v-for="(item, index) in videoArr" :key="index" :label="item.label" :value="item.id">
        </el-option>
      </el-select>

      <!-- <Button type="primary" @click="callCamera" style="margin-right: 10px;">开启摄像头</Button> -->
      <!-- <Button @click='changePhoto' style="margin-right: 10px;">切换摄像头</Button> -->
      <!--关闭摄像头-->
      <!-- <Button type="primary" @click="closeCamera">关闭摄像头</Button> -->
      <!-- <Select v-model="modelSel" style="width:200px" @change="changeSel">
        <Option v-for="(item, index) in videoArr" :value="item.id" :key="index">{{ item.label }}</Option>
      </Select> -->
      <!--图片展示-->
      <div class="video-box">
        <video ref="video" width="500" height="400" autoplay></video>
        <div v-for="item in videoArr" :key="item.id" style="margin-left: 20px;">
          {{ item.label }}: <span style="user-select: all;">{{ item.id }}</span>
        </div>
      </div>
      <!--canvas截取流-->
      <!-- <canvas ref="canvas" width="640" height="480"></canvas> -->
      <!--确认-->
      <!-- <Button type="primary" @click="photograph">拍照</Button> -->




    </div>
    <Back print="5" @toBack="toBack" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      videoArr: [],//所有的摄像头
      modelSel: '',//
      myInterval: null,
    }
  },
  // destroyed() {
  //   this.closeCamera()
  // },
  created() {
    this.changePhoto();
  },
  methods: {
    // 调用摄像头
    callCamera() {
      // H5调用电脑摄像头API
      navigator.mediaDevices.getUserMedia({
        video: true
      }).then(success => {
        // 摄像头开启成功
        this.$refs['video'].srcObject = success
        // 实时拍照效果
        this.$refs['video'].play()
      }).catch(error => {
        console.error('摄像头开启失败，请检查摄像头是否可用！')
      })
    },
    // 拍照
    photograph() {
      let ctx = this.$refs['canvas'].getContext('2d')
      // 把当前视频帧内容渲染到canvas上
      ctx.drawImage(this.$refs['video'], 0, 0, 640, 480)
      // 转base64格式、图片格式转换、图片质量压缩---支持两种格式image/jpeg+image/png
      let imgBase64 = this.$refs['canvas'].toDataURL('image/jpeg', 0.7)

      /**------------到这里为止，就拿到了base64位置的地址，后面是下载功能----------*/

      // 由字节转换为KB 判断大小
      let str = imgBase64.replace('data:image/jpeg;base64,', '')
      let strLength = str.length
      let fileLength = parseInt(strLength - (strLength / 8) * 2) // 图片尺寸  用于判断
      let size = (fileLength / 1024).toFixed(2)
      console.log(size)   // 上传拍照信息  调用接口上传图片 .........

      // 保存到本地
      let ADOM = document.createElement('a')
      ADOM.href = this.headImgSrc
      ADOM.download = new Date().getTime() + '.jpeg'
      ADOM.click()
    },
    // 返回上一页
    toBack() {
      this.closeCamera()
      setTimeout(() => {
        this.$router.back();
      }, 500);
    },
    // 关闭摄像头
    closeCamera() {
      if (!this.$refs['video'].srcObject) return
      let stream = this.$refs['video'].srcObject
      let tracks = stream.getTracks()
      tracks.forEach(track => {
        track.stop()
      })
      this.$refs['video'].srcObject = null
    },


    //切换本地摄像头
    changePhoto() {
      /**得到所有的设备*/
      navigator.mediaDevices.enumerateDevices()
        .then((devices) => {
          this.videoArr = [];
          devices.forEach((device) => {
            if (device.kind == 'videoinput') {
              this.videoArr.push({
                'label': device.label,
                'id': device.deviceId
              })
            }

          });
          console.log('列表', this.videoArr)
        })
        .catch(function (err) {
          layer.msg(err.name + ": " + err.message);
        });
    },
    //切换下拉
    changeSel(val) {
      // df1f66b92c1c8fcbf3e99918079f3cf06eead4aa66b541df1a201fd5d4e02c3a
      console.log('val', val);
      localStorage.setItem('cameraId', val)
      const videoConstraints = {};
      if (val === '') {
        videoConstraints.facingMode = 'environment';
      } else {
        videoConstraints.deviceId = { exact: val };
      }
      var constraints = {
        video: videoConstraints,
      };
      this.getUserMedia(constraints);
    },

    /**打开摄像头*/
    getUserMedia(constraints, success, error) {
      if (navigator.mediaDevices.getUserMedia) {
        //最新的标准API
        navigator.mediaDevices.getUserMedia(constraints).then(success => {
          // 摄像头开启成功
          this.$refs['video'].srcObject = success
          // 实时拍照效果
          this.$refs['video'].play()
        }).catch(error);

      } else if (navigator.webkitGetUserMedia) {
        //webkit核心浏览器
        navigator.webkitGetUserMedia(constraints, success, error)
      } else if (navigator.mozGetUserMedia) {
        //firfox浏览器
        navigator.mozGetUserMedia(constraints, success, error);
      } else if (navigator.getUserMedia) {
        //旧版API
        navigator.getUserMedia(constraints, success, error);
      }
    }

  }
}
</script>
<style scoped lang="scss">
.content {
  height: calc(100vh - 42rem);
  padding: 0 5rem;
  background-color: #F1FAFC;
}

.video-box {
  display: flex;
}
</style>